"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const theme_1 = __importDefault(require("../../styles/theme"));
const styles = react_native_1.StyleSheet.create({
    activeTabText: {
        color: theme_1.default.colors.COLOR_PRIMARY,
        fontWeight: 'bold',
    },
    inactiveTabText: {
        color: theme_1.default.colors.COLOR_GRAY,
    },
    menu: {
        borderTopRightRadius: 8,
        borderTopLeftRadius: 8,
        paddingVertical: 10,
        height: 60,
        width: '100%',
        justifyContent: 'space-between',
        elevation: 0.5,
    },
});
exports.default = styles;
